"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _components = require("@engaging-tech/components");
var _routing = require("@engaging-tech/routing");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));
var _AccountLinks = _interopRequireDefault(require("./AccountLinks"));
var _AuxillaryLinks = _interopRequireDefault(require("./AuxillaryLinks"));
var _NavItems = _interopRequireDefault(require("./NavItems"));
var _NavUserDetails = _interopRequireDefault(require("./NavUserDetails"));
var _PremiumLink = _interopRequireDefault(require("./PremiumLink"));
var _TabBar = _interopRequireDefault(require("./TabBar"));
var _Cart = _interopRequireDefault(require("./Cart"));
var Wrapper = (0, _styledComponents["default"])(_components.DesktopOnly).withConfig({
  displayName: "Navbar__Wrapper",
  componentId: "sc-ygma6t-0"
})(["background:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.light[0];
});
/**
 * The main desktop navbar.
 * @param {object} props React components passed in props
 * @param {function} props.siteLogo The site's logo. Shown on the top left
 * of the Navbar.
 * @package
 */

var NavBox = (0, _styledComponents["default"])(_components.Box).withConfig({
  displayName: "Navbar__NavBox",
  componentId: "sc-ygma6t-1"
})(["display:grid;width:100%;grid-template-columns:1fr 1fr 1fr;align-content:center;"]);
var Image = _styledComponents["default"].img.withConfig({
  displayName: "Navbar__Image",
  componentId: "sc-ygma6t-2"
})(["max-width:250px;max-height:50px;margin-left:15px;margin-right:15px;justify-self:center;"]);
var Navbar = function Navbar(_ref2) {
  var SiteLogo = _ref2.siteLogo,
    linkTo = _ref2.linkTo;
  var _useNavContext = (0, _useNavContext2["default"])(),
    cartShow = _useNavContext.cartShow,
    elevation = _useNavContext.elevation,
    height = _useNavContext.height,
    ExtraNavComponent = _useNavContext.ExtraNavComponent,
    zIndex = _useNavContext.zIndex,
    headerLogo = _useNavContext.headerLogo;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    width: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_components.Box, {
    as: "nav",
    position: "relative",
    elevation: elevation,
    pb: 4,
    width: "100%",
    style: {
      zIndex: zIndex
    }
  }, /*#__PURE__*/_react["default"].createElement(NavBox, {
    py: 2,
    px: 4,
    height: height
  }, SiteLogo && /*#__PURE__*/_react["default"].createElement(_routing.Link, {
    to: linkTo || "/"
  }, /*#__PURE__*/_react["default"].createElement(SiteLogo, null)), headerLogo ? /*#__PURE__*/_react["default"].createElement(Image, {
    src: headerLogo,
    alt: "Your company logo"
  }) : /*#__PURE__*/_react["default"].createElement(_components.Box, {
    heigh: "50px",
    width: "50px"
  }), /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    alignItems: "center",
    width: "auto",
    justifySelf: "end"
  }, /*#__PURE__*/_react["default"].createElement(_PremiumLink["default"], null), /*#__PURE__*/_react["default"].createElement(_NavUserDetails["default"], null), /*#__PURE__*/_react["default"].createElement(_AccountLinks["default"], null), /*#__PURE__*/_react["default"].createElement(_AuxillaryLinks["default"], null), ExtraNavComponent && /*#__PURE__*/_react["default"].createElement(ExtraNavComponent, null), cartShow ? /*#__PURE__*/_react["default"].createElement(_Cart["default"], null) : null)), /*#__PURE__*/_react["default"].createElement(_NavItems["default"], null)), /*#__PURE__*/_react["default"].createElement(_TabBar["default"], null));
};
var _default = exports["default"] = Navbar;